export default __webpack_public_path__ + "static/media/Shadow's Bands of the Tenth Court.2cb444de.jpg";